import type { ClaimCanceled } from '@types';
import {
  getWorkApplicationCancelationReason,
  getWorkClaimCancelationReason,
} from 'shared/utils/cancelation-reasons';
import { ShiftClaimant } from './claimants/claimant-table.types';
import { ShiftApplicationCancelled, ShiftClaimCancelled } from './cancelled/cancelled-table.types';

const isApplicant = (
  input: ShiftClaimant | ShiftApplicationCancelled | ShiftClaimCancelled
): input is ShiftApplicationCancelled => 'applicationId' in input;
const isCanceledClaim = (input: any): input is ClaimCanceled => 'cancelationActor' in input;
const isCanceled = (state: string) => state === 'canceled';
const isDenied = (state: string) => state === 'denied';

const getCancelationReason = (input: ShiftApplicationCancelled | ShiftClaimCancelled): string => {
  if (isApplicant(input) && (isCanceled(input.state) || isDenied(input.state))) {
    return getWorkApplicationCancelationReason(input.cancelationReason);
  }
  if (!isApplicant(input) && isCanceledClaim(input)) {
    return getWorkClaimCancelationReason(input.cancelationActor);
  }

  // t('status.unknown')
  return 'status.unknown';
};

export { getCancelationReason as getCancelationReason, isApplicant };
